// ========================================
//  Absolute Time Formatting
// ========================================
function formatAbsolute(date, style) {
	const locale = undefined; // use browser locale

	const formats = {
		d: { dateStyle: "short" },
		D: { dateStyle: "long" },
		t: { timeStyle: "short" },
		T: { timeStyle: "medium" },
		f: { dateStyle: "long", timeStyle: "short" },
		F: { dateStyle: "full", timeStyle: "short" }
	};

	// Standard formats using Intl
	if (formats[style]) {
		return new Intl.DateTimeFormat(locale, formats[style]).format(date);
	}

	// Custom "s" → 08/12/2025 09:05
	if (style === "s") {
		return date.toLocaleString(locale, {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit"
		});
	}

	// Custom "S" → 08/12/2025 09:05:00
	if (style === "S") {
		return date.toLocaleString(locale, {
			year: "numeric",
			month: "2-digit",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit"
		});
	}

	return "";
}



// ========================================
//  Relative Time Formatting (R)
// ========================================
function formatRelative(date, now = Date.now()) {
	const diff = Math.round((date.getTime() - now) / 1000);
	const abs = Math.abs(diff);

	let value, unit;

	if (abs < 60) {
		value = abs; unit = "second";
	} else if (abs < 3600) {
		value = Math.round(abs / 60); unit = "minute";
	} else if (abs < 86400) {
		value = Math.round(abs / 3600); unit = "hour";
	} else if (abs < 86400 * 30) {
		value = Math.round(abs / 86400); unit = "day";
	} else if (abs < 86400 * 365) {
		value = Math.round(abs / (86400 * 30)); unit = "month";
	} else {
		value = Math.round(abs / (86400 * 365)); unit = "year";
	}

	if (diff < 0) return `${value} ${unit}${value !== 1 ? "s" : ""} ago`;
	if (diff > 0) return `in ${value} ${unit}${value !== 1 ? "s" : ""}`;
	return "now";
}



// ========================================
//  Render a Single <time> Element
// ========================================
function renderTimeElement(el) {
	const ts = Number(el.dataset.timestamp);
	const fmt = el.dataset.format;
	const date = new Date(ts * 1000);

	if (fmt === "R") {
		el.textContent = formatRelative(date);
	} else {
		el.textContent = formatAbsolute(date, fmt);
	}
}


// ========================================
//  Render ALL .parsed-time Elements
// ========================================
function renderAllTimes(root = document) {
	root.querySelectorAll(".parsed-time").forEach(renderTimeElement);
}


function startRelativeTicker() {
	setInterval(() => {
		updateRelativeTimes();
	}, 1000);
}

function updateRelativeTimes()
{
	const now = Date.now();

	document.querySelectorAll('.parsed-time[data-format="R"]').forEach(el => {
		const ts = Number(el.dataset.timestamp);
		const date = new Date(ts * 1000);
		el.textContent = formatRelative(date, now);
	});
}

document.addEventListener("DOMContentLoaded", () => {

	updateRelativeTimes();
	startRelativeTicker();

});

document.addEventListener("livewire:init", () => {

	renderAllTimes();

	Livewire.hook("morphed", ({el, component}) => {

		renderAllTimes(el);

	});

});

document.addEventListener("livewire:navigated", () => {

	renderAllTimes();

});
